import { useEffect } from "react";
import dayjs from "dayjs";

export const useGanttDragHandler = ({
  boxRef,
  guideRef,
  wo = {},
  setIndex = () => {},
  setIsDragging = () => {},
  disabled = false,
}) => {
  const shift = 2;

  useEffect(() => {
    const box = boxRef.current;
    const guide = guideRef?.current;
    if (!box) return;

    let isDragging = false;
    let dragged = false;
    let startX = 0;
    let startLeft = 0;

    const onMouseDown = (e) => {
      if (wo.percent > 0 || disabled) return;

      isDragging = true;
      setIsDragging(true);
      startX = e.clientX;
      startLeft = box.offsetLeft;
      box.style.cursor = "grabbing";

      const rect = box.getBoundingClientRect();
      if (guide) {
        guide.style.display = "block";
        guide.style.left = `${rect.left - shift}px`;
      }

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    };

    const onMouseMove = (e) => {
      if (!isDragging || wo.percent > 0 || disabled) return;
      const newDays = Math.floor((e.clientX - startX) / 45);
      const deltaX = newDays * 45;
      if (newDays === 0) return;

      box.style.left = `${startLeft + deltaX}px`;

      const rect = box.getBoundingClientRect();
      if (guide) guide.style.left = `${rect.left - shift}px`;
      dragged = true;
    };

    const onMouseUp = () => {
      if (!isDragging || wo.percent > 0 || disabled) return;

      isDragging = false;
      setIsDragging(false);
      box.style.cursor = "grab";
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);

      if (guide) guide.style.display = "none";

      if (!dragged) return;

      const left = Number(box.style.left?.replace(/[a-zA-Z]/g, ""));
      const itr = (left - 23) / 45;

      const today = dayjs().utc().add(-1, "day").startOf("day");
      const startDate = dayjs(wo?.routingStart).utc().startOf("day");
      const newDate = startDate.add(itr, "day");

      if (newDate.isBefore(today)) box.style.left = `${startLeft}px`;
      else setIndex((prev) => (prev + itr >= 0 ? prev + itr : 0));

      dragged = false;
    };

    box.addEventListener("mousedown", onMouseDown);

    return () => {
      box.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [boxRef, guideRef, wo, setIndex, setIsDragging]);
};
